import { Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Box } from '@mui/system';
import Content from '../components/Layout/Content';
import FilterDropDown from '../components/filterDropDown/FilterDropDown';
import ReusableTable from '../components/ReusableTable/ReusableTable';
import {
  ASSESSMENT,
  ASSESSMENT_LIST,
  ASSESSMENTS_TABLE_HEADING as tableHeading,
} from '../shared/Strings';
import {
  ASSESSMENT_LISTING_MSG,
  assessmentsStatusFilterData,
  dateFilterData,
  NUMBER_OF_ROWS_PER_PAGE,
} from '../shared/constants';
import PaginationComponent from '../components/paginationComponent/PaginationComponent';
import { PreviewMainPage } from '@premkumarmph/assessment-library';
// import { PreviewHeader } from '@premkumarmph/assessment-library';
import { useMutation } from '@apollo/client';
import { useSnackbar } from 'notistack';
import SearchBarAssessment from '../components/SearchBar/SearchBarAssessment';
import { FETACH_ALL_ASSESSMENT_QUERY } from '../services/userQueries/userService';
import {
  assessmentsArrayConvertor,
  calculateDateFilterTimeStamp,
  getStatusFilterParamList,
} from '../shared/helper';
import { SimpleBackdrop } from '../components/SimpleBackdropComponent/SimpleBackdrop';
import AssessmentSubmission from './AssessmentSubmission';
import { useSearchParams } from 'react-router-dom';
import NotFoundPages from '../components/NotFound/NotFoundPages';

const table = {
  marginTop: 4,
  '& .css-1kn3lhz': {},
};

export const AssessmentPage = props => {
  const [searchValue, setSearchValue] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const [timeFilter, setTimeFilter] = useState('all');
  const [totalCount, setTotalCount] = useState();
  const [offset, setOffset] = useState(0);
  const [previewToggle, setPreviewToggle] = useState(false);
  const [selectedAssessment, setSelectedAssessment] = useState();
  const { enqueueSnackbar } = useSnackbar();
  const [assessmentFilteredData, setAssessmentFilteredData] = useState([]);
  const [searchProgressLoading, setSearchProgressLoading] =
    React.useState(false);
  const [refetchTableData, setRefetchTableData] = useState(false);
  const [searchStatus, setSearchStatus] = useState(false);

  const [searchParams, setSearchParams] = useSearchParams();
  const assessmentSubmissionId = searchParams.get('assessmentSubmissionId');

  const [fetchAllAssessment, fetchAllAssessmentCall] = useMutation(
    FETACH_ALL_ASSESSMENT_QUERY,
    {
      onError: err => {
        enqueueSnackbar(ASSESSMENT_LIST.ERROR_MESSAGE, {
          variant: 'error',
        });
      },
      onCompleted: res => {
        let result = res?.getAssessments?.assessmentList;
        if (searchValue || statusFilter !== 'all') {
          setSearchStatus(true);
        }
        let data = assessmentsArrayConvertor(result);
        setAssessmentFilteredData(data);
        setSearchProgressLoading(false);
        setTotalCount(res.getAssessments.count);
      },
    }
  );

  useEffect(() => {
    if (!searchParams.get('assessmentSubmissionId'))
      fetchAllAssessment({
        variables: {
          assessmentRequest: {
            assessmentInstanceId: null,
            pageableRequest: {
              count: NUMBER_OF_ROWS_PER_PAGE,
              offset: offset,
            },
            status: getStatusFilterParamList(
              statusFilter,
              assessmentsStatusFilterData
            ),
            date: String(calculateDateFilterTimeStamp(timeFilter)) || '0',
            assessentName: searchValue,
            internalRequest: false,
          },
        },
      });
  }, [searchValue, statusFilter, timeFilter, offset, refetchTableData]);

  useEffect(() => {
    if (searchParams.get('assessmentSubmissionId')) {
      async function getMeta() {
        await fetchAllAssessment({
          variables: {
            assessmentRequest: {
              assessmentInstanceId: +assessmentSubmissionId,
              pageableRequest: {
                count: 1,
                offset: 0,
              },
              internalRequest: false,
            },
          },
        });
        setPreviewToggle(true);
        sessionStorage.removeItem('redirectPathAfterLogin');
      }
      getMeta();
    }
  }, [searchParams, assessmentSubmissionId, fetchAllAssessment]);

  const handlePreview = assessment => {
    setSelectedAssessment(assessment);

    setPreviewToggle(true);
  };

  const onPageClick = pageNumber => {
    setOffset((pageNumber - 1) * 10);
  };

  const statusFilterOptions = {
    options: assessmentsStatusFilterData,
    value: statusFilter,
    changeHandler: ev => {
      setStatusFilter(ev.target.value);
      handleChangeFilter();
    },
  };

  const dateFilterOptions = {
    options: dateFilterData,
    value: timeFilter,
    changeHandler: ev => {
      setTimeFilter(ev.target.value);
      handleChangeFilter();
    },
  };

  const handleChangeFilter = () => {
    setOffset(0);
  };

  const handlePreviewToggle = value => {
    setPreviewToggle(value);
    if (searchParams.get('assessmentSubmissionId')) {
      searchParams.delete('assessmentSubmissionId');
      setSearchParams(searchParams);
    }
  };
  // const handleAssessmentButtonClick = (id, status, obj) => {
  //   console.log('handle clicked functionality', id, status, obj);
  //   setSelectedAssessment(obj);

  //   setPreviewToggle(true);
  // };

  const onSearchClick = val => {
    offset !== 0 && setOffset(0);
    setSearchValue(val);
  };

  return (
    <Content>
      <Typography variant="title">{ASSESSMENT.TITLE_TEXT}</Typography>
      {(assessmentFilteredData?.length > 0 || searchStatus) && (
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            marginTop: '20px',
          }}>
          <SearchBarAssessment
            value={searchValue}
            onChange={onSearchClick}
            fetchData={assessmentFilteredData}
            displayLoading={assessmentFilteredData?.length !== 0}
            loading={searchProgressLoading}
            placeholder="Search by assessment name"
            minLength={2}
            sx={{ marginTop: '-4px', bgcolor: 'pink' }}
          />
          <Box sx={{ mt: '-8px', display: 'flex' }}>
            <FilterDropDown
              {...dateFilterOptions}
              filterType="Assigned date:"
            />
            <FilterDropDown {...statusFilterOptions} filterType="Status:" />
          </Box>
        </Box>
      )}
      <Box sx={table}>
        {assessmentFilteredData.length > 0 && (
          <ReusableTable
            tableHeading={tableHeading}
            data={assessmentFilteredData}
            viewDetailsHandler={handlePreview}
            isAssessment={true}
            // handleAssessmentButtonClick={handleAssessmentButtonClick}
          />
        )}

        <div
          style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            marginTop: 18,
          }}>
          {totalCount > NUMBER_OF_ROWS_PER_PAGE && (
            <PaginationComponent
              numberOfRowsPerPage={NUMBER_OF_ROWS_PER_PAGE}
              count={totalCount}
              onPageClick={onPageClick}
              page={offset / 10}
            />
          )}
        </div>
      </Box>

      {assessmentFilteredData?.length === 0 && !fetchAllAssessmentCall.loading && (
        <Box sx={{ margin: '20px 0px', minHeight: '400px', display: 'flex' }}>
          <NotFoundPages
            errorMsg={ASSESSMENT_LISTING_MSG.ASSESSMENT_NOT_FOUND.helperMsg}
            errorTitle={ASSESSMENT_LISTING_MSG.ASSESSMENT_NOT_FOUND.title}
            errorIcon={ASSESSMENT_LISTING_MSG.ASSESSMENT_NOT_FOUND.iconURL}
            showButton={false}
          />
        </Box>
      )}
      {previewToggle && (
        <AssessmentSubmission
          setPreviewToggle={handlePreviewToggle}
          selectedAssessment={
            assessmentSubmissionId
              ? assessmentFilteredData?.[0] ?? {
                  assessmentInstanceId: Number(assessmentSubmissionId),
                }
              : selectedAssessment
          }
          refetchTableData={refetchTableData}
          setRefetchTableData={setRefetchTableData}
        />
      )}
      <SimpleBackdrop open={fetchAllAssessmentCall.loading} />
    </Content>
  );
};
